import { useMediaQuery, useTheme } from "@mui/material"

const useGetBreakpoint = () => {
    const theme = useTheme();
    const isXS = useMediaQuery(theme.breakpoints.down('sm'));
    const isSM = useMediaQuery(theme.breakpoints.down('md'));
    const isMD = useMediaQuery(theme.breakpoints.down('lg'));
    const isLG = useMediaQuery(theme.breakpoints.down('xl'));

    const breakpoint = isXS ? 'xs' : isSM ? 'sm' : isMD ? 'md' : isLG ? 'lg' : 'xl';

    return { breakpoint }
}

export default useGetBreakpoint;